var exports = {
  "kL": "PiPOverlay.module__container___TUh5em",
  "n_": "PiPOverlay.module__hoverOverlay___TUh5em",
  "YQ": "PiPOverlay.module__containerInteractionActive___TUh5em",
  "YL": "PiPOverlay.module__headerGradient___TUh5em",
  "VW": "PiPOverlay.module__headerContent___TUh5em",
  "LD": "PiPOverlay.module__headerLeft___TUh5em",
  "q3": "PiPOverlay.module__returnToCallButton___TUh5em",
  "fs": "PiPOverlay.module__returnToCallIcon___TUh5em",
  "Qt": "PiPOverlay.module__returnToCallLabel___TUh5em",
  "wY": "PiPOverlay.module__footerGradient___TUh5em",
  "z8": "PiPOverlay.module__footerContent___TUh5em",
  "PU": "PiPOverlay.module__footerLeft___TUh5em",
  "zz": "PiPOverlay.module__streamerName___TUh5em",
  "wV": "PiPOverlay.module__footerRight___TUh5em",
  "ti": "PiPOverlay.module__spectatorBadge___TUh5em",
  "Bh": "PiPOverlay.module__spectatorIcon___TUh5em",
  "hP": "PiPOverlay.module__actionButton___TUh5em",
  "P4": "PiPOverlay.module__disconnectButton___TUh5em",
  "gE": "PiPOverlay.module__actionIcon___TUh5em",
};

module.exports = exports;
